export default "__VITE_ASSET__B7pl_ODK__"